import React from 'react';
export function StatCell({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="min-w-0 p-4">
      <dt className="text-caption text-text-muted">{label}</dt>
      <dd className="mt-1 font-body text-metric font-semibold tabular-nums text-text-heading">
        {value == null ? <span className="text-body text-text-muted">Unknown</span> : value}
      </dd>
    </div>
  );
}
export function NumbersStrip({ children }: { children: React.ReactNode }) {
  return (
    <dl className="grid min-w-0 grid-cols-2 divide-x divide-border rounded-card border border-border bg-surface-sheet sm:flex sm:[&>*]:flex-1">
      {children}
    </dl>
  );
}
